export const GetPreferredDateFormat = (date: Date): string => {
	const d = new Date(date);
	const year = d.getFullYear();
	const month = d.getMonth() + 1;
	const day = d.getDate();
	const newDate = `${month}/${day}/${year}`;
	return newDate;
};

/**
 * Formats dates in spanish
 */
export const customDateFormatInSpanish = (date: Date): string => {
	const monthsList = [
		'Enero',
		'Febrero',
		'Marzo',
		'Abril',
		'Mayo',
		'Junio',
		'Julio',
		'Agosto',
		'Septiembre',
		'Octubre',
		'Noviembre',
		'Diciembre'
	];
	const days = ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab'];

	const d = new Date(date);
	const year = d.getFullYear();
	const dayNum = d.getDate();
	const monthName = monthsList[d.getMonth()];
	const dayName = days[d.getDay()];

	const newDate = `${dayName}, ${dayNum} ${monthName} ${year}`;
	return newDate;
};
